const Alchemy = require('../ability_trees/Alchemy');
const BowUse = require('../ability_trees/BowUse');
const Conjuration = require('../ability_trees/Conjuration');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator');
const LightHelmet = require('../../game_items/equipment/helmet/LightHelmet');
const LightTorsoe = require('../../game_items/equipment/torsoe/LightTorsoe');
const LightBoots = require('../../game_items/equipment/boots/LightBoots');
const Dagger = require('../../game_items/equipment/weapon/Dagger');
const Bow = require('../../game_items/equipment/off_hand/Bow');

module.exports = {
  handle: 'shaman',
  getAbilityTrees: () => ([
    Alchemy,
    BowUse,
    Conjuration,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 9,
    perception: 8,
    mana: 9,
    toughness: 5,
    strength: 4,
    willpower: 8,
    dexterity: 7,
  }),
  getDefaultAIConfig: () => (['interference', 'dps_ranged', 'dps_close', 'support', 'tank']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(LightHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(LightTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(LightBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Dagger, 0, 0.1, true),
    off_hand: ItemGenerator.getRandomItem(Bow, 0, 0.1, true),
  }),
};
